import React from "react";
import { Box, Typography } from "@mui/material";

export default function EntityBlock({ name, fields }) {
    return (
        <Box
            sx={{
                minWidth: 200,
                padding: 2,
                border: "2px solid #9333ea",
                backgroundColor: "#f3e8ff",
                borderRadius: 2,
                cursor: "grab"
            }}
        >
            <Typography fontWeight={700} mb={1}>
                {name}
            </Typography>
            {Array.isArray(fields) &&
                fields.map((f, idx) => (
                    <Typography key={idx} fontSize={14}>
                        {f}
                    </Typography>
                ))}
        </Box>
    );
}
